import React from 'react';
import { Organization } from '../../types/organizations';

interface BaseCreditCardProps {
  organization: Organization;
  onEditBaseCreditTerms?: () => void;
  onEditBaseCreditLimit?: () => void;
}

const BaseCreditCard: React.FC<BaseCreditCardProps> = ({ 
  organization, 
  onEditBaseCreditTerms,
  onEditBaseCreditLimit 
}) => {
  const hasBaseCreditTerms = organization.base_credit_terms && organization.base_credit_terms.trim() !== '';
  const hasBaseCreditLimit = organization.base_credit_limit !== null && organization.base_credit_limit !== undefined;

  return (
    <div className="bg-white rounded-lg shadow p-6 w-full">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Base Credit Settings</h3>
      <div className="space-y-4">
        {/* Base Credit Terms */}
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-500">Base Credit Terms:</span>
            {onEditBaseCreditTerms && (
              <button
                onClick={onEditBaseCreditTerms}
                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                {hasBaseCreditTerms ? 'Edit' : 'Set'}
              </button>
            )}
          </div>
          <div className="text-sm text-gray-900">
            {organization.base_credit_terms || 'Not specified'}
          </div>
          {organization.base_credit_terms_desc && (
            <div className="text-xs text-gray-600 mt-1">
              {organization.base_credit_terms_desc}
            </div>
          )}
        </div>
        
        {/* Base Credit Limit */}
        <div className="border-t border-gray-200 pt-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-500">Base Credit Limit:</span>
            {onEditBaseCreditLimit && (
              <button
                onClick={onEditBaseCreditLimit}
                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                {hasBaseCreditLimit ? 'Edit' : 'Set'}
              </button>
            )}
          </div>
          <div className="text-sm text-gray-900">
            {hasBaseCreditLimit
              ? `$${(organization.base_credit_limit as number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
              : 'Not specified'}
          </div>
          {organization.base_credit_limit_desc && (
            <div className="text-xs text-gray-600 mt-1">
              {organization.base_credit_limit_desc}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BaseCreditCard;

